import Vue from "vue";
import Store from "../store";
import Router from "vue-router";
Vue.use(Router);
import { Toast } from "vant";

import { isWx } from "@/utils";
import { ApiLogin, ApiGetInfo } from "@/api/login.js";

import activity from "@/views/activity";
import placeholder from "@/views/activity/placeholder";
import famousTeacher from "@/views/famousTeacher";
import brandIntro from "@/views/brandIntro";
import organization from "@/views/channel/organization";
import amuseAc from "@/views/amuseAc";
import tradInstru from "@/views/tradInstru";
import invitedUser from "@/views/invitedUser";
import invitedUserSuccess from "@/views/invitedUserSuccess";
import createMusicScore from "@/views/createMusicScore";

// import competition from '@/views/registration/entrance'
// import introduce from '@/views/registration/introduce'

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    //to top
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/placeholder",
    },
    { path: "/activity", component: activity },
    { path: "/placeholder", component: placeholder },
    { path: "/famousTeacher", component: famousTeacher },
    { path: "/brandIntro", component: brandIntro },
    { path: "/organization", component: organization },
    { path: "/amuseAc", component: amuseAc },
    { path: "/tradInstru", component: tradInstru },
    { path: "/invitedUser", component: invitedUser },
    { path: "/invitedUserSuccess", component: invitedUserSuccess },
    { path: "/createMusicScore", component: createMusicScore },
    // {path:'/competition', component: competition},
    // {path:'/introduce', component: introduce},

    // 奥林匹克青少年音乐展演
    {
      path: "/olympicMusicShow",
      component: () => import("@/views/olympicMusicShow/index.vue"),
      children: [
        {
          path: "home",
          redirect: "entryType",
          // component: () => import('@/views/registration/entrance.vue'),
        },
        {
          path: "intro",
          component: () => import("@/views/registration/introduce.vue"),
        },
        {
          path: "entryType",
          component: () => import("@/views/olympicMusicShow/entryType.vue"),
        },
        {
          path: "instruments",
          component: () => import("@/views/olympicMusicShow/instruments.vue"),
        },
        {
          path: "group",
          component: () => import("@/views/olympicMusicShow/group.vue"),
        },
        {
          path: "singleRegister",
          component: () =>
            import("@/views/olympicMusicShow/singleRegister.vue"),
        },
        {
          path: "singleRegister2",
          component: () =>
            import("@/views/olympicMusicShow/singleRegister2.vue"),
        },
        {
          path: "multiRegister",
          component: () => import("@/views/olympicMusicShow/multiRegister.vue"),
        },
        {
          path: "member",
          component: () =>
            import("@/views/olympicMusicShow/multiRegisterMember.vue"),
        },
        {
          path: "memberAdd",
          component: () =>
            import("@/views/olympicMusicShow/multiRegisterMemberAdd.vue"),
        },
        {
          path: "records",
          component: () => import("@/views/olympicMusicShow/records.vue"),
        },
        {
          path: "record",
          component: () => import("@/views/olympicMusicShow/record.vue"),
        },
        {
          path: "bindPhone",
          component: () => import("@/views/olympicMusicShow/bingPhone.vue"),
        },
        {
          path: "smsCode",
          component: () => import("@/views/olympicMusicShow/smsCode.vue"),
        },
      ],
    },

    // 课程市场
    {
      path: "/onlineLearningMyCourse",
      component: () => import("@/views/onlineLearning/myCourse.vue"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/onlineLearning",
      redirect: "/onlineLearning/courseMarket",
      component: () => import("@/views/onlineLearning/index.vue"),
      children: [
        {
          path: "test",
          component: () => import("@/views/onlineLearning/test.vue"),
          meta: {
            keepAlive: true,
          },
        },
        {
          path: "courseMarket",
          component: () => import("@/views/onlineLearning/courseMarket.vue"),
          meta: {
            keepAlive: true,
          },
        },
        {
          path: "myCourse",
          component: () => import("@/views/onlineLearning/myCourse.vue"),
          meta: {
            keepAlive: false,
          },
        },
        {
          path: "courseDetail",
          component: () => import("@/views/onlineLearning/courseDetail.vue"),
        },
        {
          path: "income",
          component: () => import("@/views/onlineLearning/income.vue"),
        },
        {
          path: "incomeRecords",
          component: () => import("@/views/onlineLearning/incomeRecords.vue"),
        },
        {
          path: "scanCodePay",
          component: () => import("@/views/onlineLearning/scanCodePay.vue"),
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let isApp = to.query.isApp;
  let terminal = to.query.terminal;

  if (isApp) {
    Store.commit("index/setIsApp", isApp);
  }
  if (terminal) {
    Store.commit("index/setTerminal", terminal);
  }

  if (
    to.path.indexOf("onlineLearning") > -1 ||
    to.path.indexOf("onlineLearningMyCourse") > -1
  ) {
    // 课程市场/我的课程
    if (
      (isApp == "true" && terminal != 5) ||
      (Store.state.index.isApp == "true" && Store.state.index.terminal != 5)
    ) {
      // app
      if (!Store.state.index.dayulongNumber) {
        DYL.getUserInfo(
          (window["success"] = (data) => {
            if (typeof data != "object") {
              data = JSON.parse(data);

              Store.commit("index/setPhoneNumber", data.phoneNumber);
              Store.commit("index/setDayulongNumber", data.dayulongNumber);
              Store.commit("index/setIsWeChatBind", data.isWeChatBind);
              Store.commit("index/setIsCertification", data.isCertification);
            } else {
              // ios
              Store.commit("index/setPhoneNumber", data.phoneNumber);
              Store.commit("index/setDayulongNumber", data.dayulongNumber);
              Store.commit("index/setIsWeChatBind", data.isWeChatBind);
              Store.commit("index/setIsCertification", data.isCertification);
            }
          })
        );

        DYL.getTokenInfo(
          (window["success"] = (data) => {
            if (typeof data != "object") {
              data = JSON.parse(data);
              localStorage.setItem("appUserToken", data.access_token);
              // ApiGetInfo().then(res => {
              // 	if (res.code === 200) {
              // 		let data = res.data
              // 		data.userId = data.id
              // 		Store.commit('index/setUserInfo', data)
              // 	}
              // })
              next();
            } else {
              // ios
              localStorage.setItem("appUserToken", data.access_token);
              next();
            }
          })
        );
      } else {
        next();
      }
    } else {
      // 小程序
      let token = to.query.token;
      let phoneNumber = to.query.phoneNumber;
      let payState = to.query.payState;
      let dayulongNumber = to.query.dayulongNumber;
      let isWeChatBind = to.query.isWeChatBind === "true" ? true : false;
      let isCertification = to.query.isCertification === "true" ? true : false;

      if (payState) {
        Store.commit("index/setPayState", payState);
      }

      if (token) {
        Store.commit("index/setPhoneNumber", phoneNumber);
        Store.commit("index/setDayulongNumber", dayulongNumber);
        Store.commit("index/setIsWeChatBind", isWeChatBind);
        Store.commit("index/setIsCertification", isCertification);
        localStorage.setItem("appUserToken", token);

        // ApiGetInfo().then(res => {
        // 	if (res.code === 200) {
        // 		let data = res.data
        // 		data.userId = data.id
        // 		Store.commit('index/setUserInfo', data)
        // 	}
        // })

        let query = to.query;
        if (query.payState) {
          delete query.payState;
          next({ path: to.path, query: { ...query } });
          return false;
        }
      }

      next();
      return false;
    }
  }

  if (!Store.state.olympicMusicShow.channelId && to.query.channelId) {
    Store.commit("olympicMusicShow/setChannelId", to.query.channelId);
  }
  if (!Store.state.olympicMusicShow.competitionId) {
    let competitionId = to.query.competitionId || "1";
    Store.commit("olympicMusicShow/setCompetitionId", competitionId);
  }

  // console.log(location.href, to.query, to.query.code)
  // next()
  // return false

  if (
    (isApp == "true" && terminal != 5) ||
    (Store.state.index.isApp == "true" && Store.state.index.terminal != 5)
  ) {
    // app
    next();
    return false;
  }

  if (
    (to.path.indexOf("/olympicMusicShow") > -1 &&
      to.path !== "/olympicMusicShow/home" &&
      to.path !== "/olympicMusicShow/intro" &&
      to.path !== "/olympicMusicShow/bindPhone" &&
      to.path !== "/olympicMusicShow/smsCode") ||
    to.query.code
  ) {
    let wxCode = "";
    if (Store.state.index.wxCode) {
      wxCode = Store.state.index.wxCode;
    } else {
      // alert(JSON.stringify(to))
      if (to.query.code) {
        wxCode = to.query.code;
        Store.commit("index/setWxCode", wxCode);
      }
    }
    if (wxCode) {
      // return false
      if (!Store.state.index.userInfo) {
        let params = {
          wxcode: wxCode,
          loginType: 13,
          scope: "Dayulong offline_access",
          client_id: "Dayulong_App",
          client_secret: "Dayulong88888888",
          grant_type: "password",
          username: wxCode,
          password: wxCode,
        };

        let result;
        try {
          result = await ApiLogin(params);
          console.log("router ApiLogin", result);

          localStorage.setItem("appUserToken", result.access_token);

          ApiGetInfo().then((res) => {
            if (res.code === 200) {
              let data = res.data;
              data.userId = data.id;
              Store.commit("index/setUserInfo", data);

              let query = to.query;
              if (query.hasOwnProperty("code")) {
                delete query.code;
              }
              if (query.hasOwnProperty("state")) {
                delete query.state;
              }
              next({ path: to.path, query: { ...query } });
            } else {
              Toast(res.msg);
              next();
            }
          });
        } catch (error) {
          let error_description = error.response.data.error_description;
          console.log("error", error, error.response, error_description);
          if (error_description === "需要绑定手机号") {
            console.log("需要绑定手机号");
            let openId = error.response.data.open_id;
            localStorage.setItem("openId", openId);
            next({ path: "/olympicMusicShow/bindPhone" });
          }
        }
      } else {
        next();
      }
    } else {
      let originUrl = encodeURIComponent(location.href);
      location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        Store.state.index.appId +
        "&redirect_uri=" +
        originUrl +
        "&response_type=code&scope=snsapi_userinfo&state=2";
    }
  } else {
    next();
  }
});

export default router;
